import React from "react";
import { useSearchParams } from "react-router-dom";
import CommissionDetailPage from "./CommissionDetailPage";
import { canViewCommissionModule } from "../../../utilis/invoicePermissionHelpers";
import {
  hasCommissionDetailParams,
  parseCommissionDetailParams,
} from "./commissionDetailUtils";
import "../../../styles/tailwind.css";

function CommissionDetailRoute() {
  const [searchParams] = useSearchParams();
  const params = parseCommissionDetailParams(searchParams);

  if (!canViewCommissionModule()) {
    return (
      <div className="tailwind-container p-4">
        <p className="text-muted mb-0">
          You do not have permission to view the commission module.
        </p>
      </div>
    );
  }

  if (!hasCommissionDetailParams(params)) {
    return (
      <CommissionDetailPage
        params={null}
        missingParams
      />
    );
  }

  return <CommissionDetailPage params={params} />;
}

export default CommissionDetailRoute;
